import React, { useContext, useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthenticationContext } from '../../../contexts/authentication';
import './NavigationBar.css';

const NavigationBar = () => {
    const { isLoggedIn } = useContext(AuthenticationContext);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            // Close mobile menu on larger screens
            if (window.innerWidth > 768) {
                setIsMobileMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMobileMenuOpen && !event.target.closest('.navigation-bar')) {
                setIsMobileMenuOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [isMobileMenuOpen]);

    // Prevent body scroll when mobile menu is open
    useEffect(() => {
        if (isMobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isMobileMenuOpen]);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    if (!isLoggedIn) return null;

    return (
        <nav className='navigation-bar'>
            <div className='navigation-bar-container'>
                {/* Logo/Brand Section */}
                <NavLink
                    to="/"
                    className="navigation-bar-brand"
                    onClick={closeMobileMenu}
                >
                    <div className='brand-icon'>
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            viewBox="0 0 24 24" 
                            fill="currentColor"
                            width="28"
                            height="28"
                        >
                            <path d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H4V5h16v14zM6 7h12v2H6zm0 4h12v2H6zm0 4h8v2H6z"/>
                        </svg>
                    </div>
                    <span className='brand-text'>
                        <span className='brand-text-full'>Access-Solutions-ASI</span>
                        <span className='brand-text-short'>ASI</span>
                    </span>
                </NavLink>

                {/* Hamburger Menu Button */}
                <button 
                    className={`hamburger-menu ${isMobileMenuOpen ? 'active' : ''}`}
                    onClick={toggleMobileMenu}
                    aria-label="Toggle navigation menu"
                    aria-expanded={isMobileMenuOpen}
                >
                    <span className='hamburger-line'></span>
                    <span className='hamburger-line'></span>
                    <span className='hamburger-line'></span>
                </button>

                {/* Mobile Menu Overlay */}
                <div 
                    className={`mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`}
                    onClick={closeMobileMenu}
                ></div>

                {/* Navigation Links Wrapper */}
                <div className={`navigation-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                    {/* Navigation Links - Left */}
                    <div className='navigation-bar-left'>
                        <NavLink 
                            to="/jobs" 
                            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                            onClick={closeMobileMenu}
                        >
                            <span className='nav-icon'>📋</span>
                            <span className='nav-text'>Jobs</span>
                        </NavLink>
                        
                        <NavLink 
                            to="/requests" 
                            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                            onClick={closeMobileMenu}
                        >
                            <span className='nav-icon'>📨</span>
                            <span className='nav-text'>Requests</span>
                        </NavLink>
                        
                        <NavLink 
                            to="/schedule" 
                            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                            onClick={closeMobileMenu}
                        >
                            <span className='nav-icon'>📅</span>
                            <span className='nav-text'>Schedule</span>
                        </NavLink>
                    </div>

                    {/* Navigation Links - Right */}
                    <div className='navigation-bar-right'>
                        <NavLink 
                            to="/logout" 
                            className={({ isActive }) => isActive ? 'nav-link logout-link active' : 'nav-link logout-link'}
                            onClick={closeMobileMenu}
                        >
                            <span className='nav-icon'>🚪</span>
                            <span className='nav-text'>Logout</span>
                        </NavLink>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default NavigationBar;
